// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.tep-nagr-system-title[data-v-208dd9ac] {\r\n    padding: 0 0 4px;\n}\n.tep-nagr-system-grid[data-v-208dd9ac] {\r\n    display: grid;\r\n    gap: 8px;\r\n    grid-template-columns: 32px 1fr;\n}\n.tep-nagr-system-no-label[data-v-208dd9ac] .dx-field-label {\r\n    display: none;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
